module.exports = __webpack_public_path__ + "static/media/mode-16.22c8804f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-16.svg
// module id = 971
// module chunks = 2